var portfolioEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Cancel",
	title: "Edit virtual portfolio",
	nameInputLabel: "Portfolio Name",
	nameInputPlaceholder: "Please enter a name",
	nameInputTip: "Max. 100 characters – Valid characters: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Portfolio Base Currency",
	currencyInputPlaceholder: "Please select a currency",
	limitExceededMessage: "Portfolio limit exceeded.",
	currencies: {
		euro: "Euro",
		usd: "US Dollars",
		chf: "Swiss Franks",
		gbp: "British Pound",
		jpy: "Japanese Yen",
		cad: "Canadian Dollar"
	},
	validationErrors: {
		name: {
			invalidInput: "Name is invalid. Max. 100 characters – Valid characters: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var en = {
	portfolioEdit: portfolioEdit
};

export { en as default, portfolioEdit };
